export const getPaymentMethodColor = (method: string) => {
  switch (method) {
    case "credit_card":
      return "#9FA3AD";
    case "paypal":
      return "#2170EB";
    case "apple_pay":
      return "#F47516";
    case "google_pay":
      return "#16B37F";
    default:
      return "#D3D3D3";
  }
};
